// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
.customButton, .PlaygroundTileCloseButton {
  background-color: var(--button-bg);
  color: var(--button-fg);
  border-radius: 25px;
  border: 1px solid var(--button-border-color);
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  font-family: "Signika Negative", sans-serif, Arial;
  font-size: 1rem !important;
}

.customButton i, .PlaygroundTileCloseButton i {
  font-size: 1rem;
}

.PlaygroundTileCloseButton {
  position: absolute;
  top: 5%;
  left: 98%;
  transform: translate(-50%, -50%);
}

@media (max-width: 767px) {
  .close-icon {
    top: 2% !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .close-icon {
    top: 3% !important;
  }
}

.disclaimer {
  display: None;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: var(--color-fg);
  background-color: var(--color-bg);
  opacity: 0.4;
  pointer-events: none;
}
@supports (-webkit-touch-callout: none) {
  .disclaimer {
    /* CSS specific to iOS devices */
    position: fixed;
  }
}
@supports not (-webkit-touch-callout: none) {
  .disclaimer {
    /* CSS for other than iOS devices */
    position: absolute;
  }
}
@media (max-width: 767px) {
  .disclaimer {
    font-size: 0.6em;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .disclaimer {
    padding: 0.1em;
    font-size: 0.8em;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .disclaimer {
    padding: 0.1em;
    font-size: 0.8em;
  }
}

.link {
  color: var(--color-hover);
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/CustomButton.scss","webpack://./src/components/PlaygroundTile.scss"],"names":[],"mappings":"AAAA,0BAAA;ACAA;EACI,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,kDAAA;EACA,0BAAA;ACEJ;;ADCA;EACI,eAAA;ACEJ;;AAXA;EAGI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,gCAAA;AAYJ;;AFhBE;EEOF;IAEQ,kBAAA;EAYN;AACF;AFfE;EEAF;IAMQ,kBAAA;EAaN;AACF;;AAVA;EACI,aAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,YAAA;EACA,oBAAA;AAaJ;AAXI;EAXJ;IAYQ,gCAAA;IACA,eAAA;EAcN;AACF;AAZI;EAhBJ;IAiBQ,mCAAA;IACA,kBAAA;EAeN;AACF;AFnDE;EEiBF;IAsBQ,gBAAA;EAgBN;AACF;AFjDE;EEUF;IA0BQ,cAAA;IACA,gBAAA;EAiBN;AACF;AFhDE;EEGF;IA+BQ,cAAA;IACA,gBAAA;EAkBN;AACF;;AAfA;EAEI,yBAAA;EACA,mBAAA;AAiBJ","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}",".customButton {\n    background-color: var(--button-bg);\n    color: var(--button-fg);\n    border-radius: 25px;\n    border: 1px solid var(--button-border-color);\n    padding: .5rem 1.5rem;\n    cursor: pointer;\n    font-family: \"Signika Negative\", sans-serif, Arial;\n    font-size: 1rem!important;\n}\n\n.customButton i {\n    font-size: 1rem;\n}","@use '../styles';\n@use 'CustomButton.scss';\n\n.PlaygroundTileCloseButton {\n    @extend .customButton;\n    // Position this in the center\n    position: absolute;\n    top: 5%;\n    left: 98%;\n    transform: translate(-50%, -50%);\n}\n\n.close-icon {\n    @include styles.mobile {\n        top: 2% !important;\n    }\n\n    @include styles.tablet {\n        top: 3% !important;\n    }\n}\n\n.disclaimer {\n    display: None;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    color: var(--color-fg);\n    background-color: var(--color-bg);\n    opacity: 0.4;\n    pointer-events: none;\n\n    @supports (-webkit-touch-callout: none) {\n        /* CSS specific to iOS devices */ \n        position: fixed;\n    }\n      \n    @supports not (-webkit-touch-callout: none) {\n        /* CSS for other than iOS devices */ \n        position: absolute;\n    }\n\n    @include styles.mobile {\n        font-size: 0.6em;\n    }\n\n    @include styles.tablet {\n        padding: 0.1em;\n        font-size: 0.8em;\n    }\n\n    @include styles.desktop {\n        padding: 0.1em;\n        font-size: 0.8em;\n    }\n}\n\n.link {\n    // Show in var(--color-hover)\n    color: var(--color-hover);\n    pointer-events: all;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
